import { client } from "@/api/client.gen";

const { VITE_API_BASE_URL } = import.meta.env;

function normalizeApiBaseUrl(value: string | undefined): string {
  const baseUrl = value?.trim().replace(/\/+$/, "") ?? "";
  if (!baseUrl) return "/api";
  return baseUrl === "/api" || baseUrl.endsWith("/api")
    ? baseUrl
    : `${baseUrl}/api`;
}

// Configure the shared client before app-shell defines and connects the root
// custom element. This prevents the initial auth probe from using the
// generated client's default relative /api URL during module startup.
client.setConfig({
  baseUrl: normalizeApiBaseUrl(VITE_API_BASE_URL),
  credentials: "include",
  // The browser's timezone, so the server can turn calendar dates (e.g. a
  // cycle's start/end) into local times.
  headers: { "X-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone },
});
